import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import { Form, Button, Select, Divider, Row, Col, message, Input, InputNumber } from 'antd';
import { receiptFindSpecialRuleVariable, specialRulesLabelAdd,specialRulesLabelUpdateById } from '@/services/fmsConfig'
// @ts-ignore
export function modalAddOrEditFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `${rest?.id ? '编辑方案' : '新增方案'}`,
    width: 500,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}
// @ts-ignore
const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const [specialRuleList, setSpecialRuleList] = useState([]);
  const { Option } = Select
  useEffect(() => {
    initFn();
    getOptions()
  }, []);

  const initFn = () => {
    const { id, labelName, orderVal, variablesCode } = rest;
    if (rest?.id) {
      // 回显数据
      form.setFieldsValue({
        id,
        labelName,
        orderVal,
        variablesCode: variablesCode.split(',')
      });
    }
  };
  const getOptions = async () => {
    let specialRuleLists = await receiptFindSpecialRuleVariable()
    setSpecialRuleList(specialRuleLists)
  }
  // 提交
  const onFinish = (values: any) => {
    const { id } = rest;
    let newValues = { ...values };
    newValues.variablesCode = newValues.variablesCode.join(',') || ''
    setAddOrEditFooterLoading(true);
    if(id){
      specialRulesLabelUpdateById({ ...newValues, ...(id && { id }) })
      .then((resp: any) => {
        setAddOrEditFooterLoading(false);
        message.info(resp?.message || '操作成功');
        onClose();
        fn && fn();
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
    }else{
      specialRulesLabelAdd({ ...newValues, ...(id && { id }) })
      .then((resp: any) => {
        setAddOrEditFooterLoading(false);
        message.info(resp?.message || '操作成功');
        onClose();
        fn && fn();
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
    }
  };
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  return (
    <div style={{ padding: 15 }}>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item label="方案名称" name="labelName" {...formItemLayout} rules={[{ required: true, message: '请输入方案名称' }]}>
          <Input placeholder="请输入方案名称" maxLength={20} />
        </Form.Item>
        <Form.Item
          label="方案优先级"
          name="orderVal"
          {...formItemLayout}
          rules={[{ required: true, message: '请输入方案优先级' }]}
          
        >
          <InputNumber placeholder="输入数字" min={1} style={{width: '100%'}} parser={value => value ? value.replace(/\D/g, '') : ''}
                    formatter={value => value ? `${value}`.replace(/\D/g, '') : ''} />
        </Form.Item>
        <Form.Item label="方案变量" name="variablesCode" {...formItemLayout} rules={[{ required: true, message: '方案变量' }]}>
        <Select
            placeholder="请选择方案变量"
            allowClear
            showSearch
            optionFilterProp="children"
            mode="multiple"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
            }
          >
            {specialRuleList?.map((item: any) => {
              return (
                <Option key={item.code} value={item.code}>
                  {item.desc}
                </Option>
              )
            })}
          </Select>
        </Form.Item>
        <Form.Item style={{marginBottom: 10}}>
          <Row>
            <Col span={24}>
              <Divider />
            </Col>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
                取消
              </Button>
              <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={addOrEditFooterLoading}>
                保存
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </div>
  );
};
